'use client';

import { APP_PLATFORM } from '@/utils/constants';
import { PlatformBridgeBase } from './base';

export class PlatformBridgeAndroid extends PlatformBridgeBase {
    platform = APP_PLATFORM.Android;
    bridgeCommands = [
        'isWrapper',
        'canOpenAccountHub',
        'openAccountHub',
        'triggerLocateUser',
        'onEvent',
        'savePreference',
        'getPreference',
        'setStatusBarBackground',
        'logout',
        'getShowBalance',
        'redirectToBrowser',
        'openExternalWebView',
        'hasNotificationPermission',
        'requestNotificationPermission',
        'openStateSelector',
        'setGameplayOrientationUnlocked'
    ];

    constructor() {
        super();
        this.bridge = window.AndroidWrapper;
    }

    public isCompatible = () => !!this.bridge?.isWrapper();

    protected isWrapper() {
        return this.isCompatible();
    }

    protected onEvent(...params: unknown[]) {
        try {
            this.bridge.onEvent(...params);
        } catch (error) {
            console.error('Error onEvent invocation.', error);
        }
    }

    protected canOpenAccountHub() {
        return this.bridge.canOpenAccountHub?.();
    }

    protected openAccountHub() {
        this.bridge.openAccountHub?.();
    }

    protected logout() {
        this.bridge.logout();
    }

    protected savePreference(key: string, value: unknown) {
        this.bridge.savePreference?.(key, value);
    }

    protected getPreference(key: string) {
        return this.bridge.getPreference?.(key);
    }

    protected setStatusBarBackground(key?: string) {
        return this.bridge.setStatusBarBackground?.(key ?? '');
    }

    protected getShowBalance() {
        return this.bridge.getShowBalance?.();
    }

    protected redirectToBrowser(url: string) {
        if (window?.Android?.redirectToBrowser) {
            window.Android.redirectToBrowser(url);
        } else if (this.bridge?.redirectToBrowser) {
            this.bridge.redirectToBrowser(url);
        }
    }

    protected openExternalWebView(url: string) {
        if (window?.AndroidSportsbook?.openExternalWebView) {
            window.AndroidSportsbook.openExternalWebView(url);
        } else if (this.bridge?.openExternalWebView) {
            this.bridge.openExternalWebView(url);
        }
    }

    protected hasNotificationPermission(): boolean {
        return this.bridge.hasNotificationPermission?.() ?? false;
    }

    protected requestNotificationPermission(): void {
        this.bridge.requestNotificationPermission?.();
    }

    protected openStateSelector(): boolean {
        if (this.bridge?.openStateSelector) {
            this.bridge.openStateSelector();
            return true;
        }
        return false;
    }

    protected setGameplayOrientationUnlocked(unlocked: boolean) {
        this.bridge?.setGameplayOrientationUnlocked?.(unlocked);
    }
}
